<template>
  <div class="table-container">
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th>{{$t('name_journeys')}}</th>
        <th class="text-right">{{$t('actions_payment')}}</th>
      </tr>
      </thead>
      <tbody class="tbody-container">
      <tr class="tr-class" v-if="!loading" v-for="dep in deps" >
        <td class="td-style">
          <span class="category-tag">{{ dep.name }}</span>
        </td>
        <td class="td-style action-icons text-right">
          <button class="dark-button-sm" @click="openAssignAgentModal(dep)">{{$t('assign_agent')}}</button>
          <button class="dark-button-sm" @click="openAssignGameLabsModal(dep)">{{$t('assign_game_test')}}</button>
          <button class="dark-button-sm" @click="openAssignTestModal(dep)">{{$t('assign_new_test')}}</button>
          <button class="dark-button-sm" @click="openAssignModal(dep)">{{$t('assign_new_program')}}</button>
          <img src="@/assets/images/trashOutline.svg" alt="Delete" class="action-icon" @click="() => deleteDepartment(dep.departmentId)" />
          <img src="@/assets/images/editPenOutline.svg" alt="Edit" class="action-icon" @click="() => editDepartment(dep)" />
        </td>
      </tr>
      <tr v-else>
        <td colspan="7" class="table-loading">
          <VueSpinner size="16" height="100%" color="#8c8c8c" />
          <span class="text">{{$t('loading')}}</span>
        </td>
      </tr>
      <tr v-if="!loading && deps.length === 0 ">
        <td colspan="7" class="table-loading">
          <span class="text">{{$t('no_data_found')}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <AssignProgramModal
      :visible="assignmentModal"
      :pre-data="details"
      type="department"
      :on-hide="hideAssignModal"
      :department-assign="true"
      :selected-department="selectedDepartmentId"
  />

  <AssignTestModal
      :visible="assignTestModal"
      :pre-data="details"
      type="department"
      :on-hide="hideAssignTestModal"
      :selected-department="selectedDepartmentId"
  />

  <AssignGameLabsModal
      :visible="assignGameLabsModal"
      :pre-data="details"
      type="department"
      :on-hide="hideAssignGameLabsModal"
      :selected-department="selectedDepartmentId"
  />

  <AssignAgentModal
      :visible="assignAgentModal"
      :company-id="companyId"
      :department-id="selectedDepartmentId"
      type="department"
      :on-hide="hideAssignAgentModal"
      :refresh-callback="() => {}"
  />

</template>

<script>
import AddUserModal from '@/components/modals/InviteUserModal.vue';
import FilterModal from '@/components/tables/Company/CompanyFilterModal.vue';
import CompanyFieldFilter from '@/components/table-filters/CompanyFieldFilter.vue';
import ProgramFilter from "@/components/table-filters/NumberFilter.vue";
import UserAmountFilter from "@/components/table-filters/MinMaxNumberFilter.vue";
import PaymentVolume from "@/components/table-filters/PaymentVolume.vue";
import DateFilter from "@/components/table-filters/DateFilter.vue";
import {VueSpinner} from "vue3-spinners";
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import AssignProgramModal from "@/components/modals/AssignProgramModal.vue";
import AssignTestModal from "@/components/modals/AssignTestModal.vue";
import userService from "@/service/userService";
import AssignGameLabsModal from "@/components/modals/AssignGameLabsModal.vue";
import AssignAgentModal from "@/components/modals/AssignAgentModal.vue";

export default {
  components: {
    AssignTestModal, AssignProgramModal, AssignGameLabsModal, AssignAgentModal,
    DateFilter,
    PaymentVolume,
    UserAmountFilter,
    AddUserModal,
    FilterModal,
    CompanyFieldFilter,
    ProgramFilter,
    ExpandableSearch,
    VueSpinner
  },

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    addNewDepartment: {
      type: Function,
      default: () => {}
    },
    editDepartment: {
      type: Function,
      default: () => {}
    },
    deleteDepartment : {
      type: Function,
      default: () => {}
    },
    deps: {
      type: Array,
      default: []
    },
    companyId: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      details: {},
      assignmentModal:false,
      assignTestModal:false,
      assignGameLabsModal:false,
      assignAgentModal:false,
      showModal: false,
      selectAll:false,
      showFilter:false,
      searchText: '',
      selectedDepartmentId:"",
    }
  },
  mounted() {
   // this.getDetails();
  },
  methods: {

   /* getDetails() {
      const routeParams = this.$route.params;
      this.isLoading = true;

      userService.getUserDetails(routeParams.id).then((response) => {
        this.details = response.data.data;
        this.isLoading = false;
      });
    },*/



    openAssignGameLabsModal(dep) {
      this.assignGameLabsModal = true;
      this.selectedDepartmentId = dep.departmentId;
    },

    openAssignModal(dep) {
      this.assignmentModal = true;
      this.selectedDepartmentId=dep.departmentId;
    },
    openAssignTestModal(dep) {
      this.assignTestModal = true;
      this.selectedDepartmentId=dep.departmentId;
    },
    hideAssignModal() {
      this.assignmentModal = false;
    },
    hideAssignTestModal() {
      this.assignTestModal = false;
    },

    hideAssignGameLabsModal() {
      this.assignGameLabsModal = false;
    },

    openAssignAgentModal(dep) {
      this.assignAgentModal = true;
      this.selectedDepartmentId = dep.departmentId;
    },
    hideAssignAgentModal() {
      this.assignAgentModal = false;
    },

  },

}
</script>

<style>

.name-row span {
  font-family: euclid_medium, sans-serif;
  color: #000;
}

.name-row:hover.name-row span{
  color: #4A68F8;
}

.flags img {
  height: 18.66px;
  width: 28px;
  border-radius: 4px;
}

.category-tag {
  margin-right: 5px;
}

.category-tag.primary {
  background-color: #4A68F8;
  color: #FFF;
}

.category-tag.warning {
  background-color: #FF8E55;
  color: #FFF;
}

.category-tag.danger {
  background-color: #FF5B5B;
  color: #FFF;
}

.category-tag.success {
  background-color: #00D68F;
  color: #FFF;
}

.text-right {
  text-align: right;
}

.action-icons {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: flex-end;
}

.action-icon {
  width: 18px;
  height: 18px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}
</style>
